export default function Branch({branch}) {
    return (
        <div className={"bg-white border border-inactive-grey rounded-lg p-[24px] lg:p-[40px] text-center"}>
            <div className={"text-lg font-bold"}>
                {branch.name}
            </div>
            {branch.phone && (
                <div>
                    <a href={`tel:${branch.phone}`} className={"text-brand-blue !font-bold"}>{branch.phone}</a>
                </div>
            )}
            {branch.email && (
                <div>
                    <a href={`mailto:${branch.email}`} className={"text-brand-blue !font-bold"}>Email</a>
                </div>
            )}
        </div>
    )
}
